import { Badge, Button, Modal } from "antd";
import { observer } from "mobx-react"
import * as React from "react";
import { observable } from "mobx";

import { ObjectUtils } from "src/core/utils/object";
import { NoteListController } from "../../general/notes/list/note-list.controller";
import { ZuluIcon } from "src/app/shared/icon";

interface NoteViewProps {
	record: { [prop: string]: NoteItem[] };
	noteProperty: string;
	mode: ControlMode;
	setBusy: (isBusy: boolean) => void;
	identityService: any;
}

@observer
export class NoteView extends React.Component<NoteViewProps, {}> {
	@observable
	private showNotesModal: boolean;

	@observable
	private notes: NoteItem[];

	private notesDeletes: NoteItem[] = [];

	componentDidMount() {
		const { record, noteProperty } = this.props;

		this.notes = record[noteProperty]
			? record[noteProperty].map(this.mapNote)
			: [];
	}

	public componentWillReceiveProps(nextProps: Readonly<NoteViewProps>) {
		const { record, noteProperty } = this.props;

		if (
			!ObjectUtils.equals(nextProps.record[noteProperty], record[noteProperty]) ||
			nextProps.record[noteProperty] != null &&
			nextProps.record[noteProperty].length !== record[noteProperty].length
		) {
			this.notes = record[noteProperty]
				? record[noteProperty].map(this.mapNote)
				: [];
		}
	}
	public render() {
		const { mode, setBusy, identityService } = this.props;

		return (
			<React.Fragment>
				<Button
					onClick={() => this.showNotesDialog()}
					className="top-1"
				>
					<Badge offset={[-10, 0]} count={this.notes ? this.notes.length : 0}>
						<ZuluIcon type="book" />
					</Badge>
				</Button>
				<Modal
					style={{ top: 20 }}
					width="800px"
					visible={this.showNotesModal}
					onCancel={this.cancelNotesDialog}
					title="Notes"
					maskClosable={false}
					footer={[<Button key="confirm" type="primary" onClick={this.acceptNotesDialog}>OK</Button>]}
				>
					<NoteListController
						model={this.notes}
						mode={mode}
						isModal={true}
						setDeleteNode={this.setDeleteNode}
						identityService={identityService}
						setBusy={setBusy}
					/>
				</Modal>
			</React.Fragment>
		);
	}

	private mapNote = (e: NoteItem): NoteItem => {
		if (e.id.startsWith("create")) {
			e.id = e.id.replace("create", "");
		}

		return {
			id: e.id,
			title: e.title,
			children: e.children ? e.children.map(this.mapNote) : undefined,
			userName: e.userName,
			msg: e.msg,
			html: e.html,
			creationDate: e.creationDate,
			visibility: {
				client: e.visibility.client.map(c => c),
				agent: e.visibility.agent.map(a => a),
				supplier: e.visibility.supplier.map(s => s),
			},
			type: e.type,
		};
	}

	private showNotesDialog = () => {
		const { record, noteProperty } = this.props;
		if (record[noteProperty] == null) {
			record[noteProperty] = [];
		}
		this.showNotesModal = true;
	}

	private setDeleteNode = (e: NoteItem) => {
		if (this.notesDeletes.findIndex(n => n.id == e.id) == -1) {
			this.notesDeletes.push(e);
		}
	}

	private acceptNotesDialog = () => {
		if (this.notes) {
			const { record, noteProperty } = this.props;
			for (const deleted of this.notesDeletes) {
				const index = this.notes.findIndex(x => x.id == deleted.id);
				if (index != -1) {
					this.notes.splice(index, 1);
				}
			}
			record[noteProperty] = this.notes.map(this.mapNote);
		}
		this.notesDeletes.splice(0, this.notesDeletes.length);
		this.showNotesModal = false;
	}

	private cancelNotesDialog = () => {
		//eliminando los creados
		for (const note of this.notes) {
			if (note.id.startsWith("create")) {
				const index = this.notes.findIndex(n => n.id == note.id);
				if (index != -1) {
					this.notes.splice(index, 1);
				}

			}
		}
		// adicionando los eliminados
		if (this.notesDeletes.length > 0) {
			for (const deleted of this.notesDeletes) {
				if (this.notes.findIndex(n => n.id == deleted.id) == -1) {
					this.notes.push(deleted);
				}
			}
		}
		this.notesDeletes.splice(0, this.notesDeletes.length);
		this.showNotesModal = false;
	}

}



// WEBPACK FOOTER //
// ./src/app/bookings/shared/note.view.tsx